import React from 'react';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import SearchInput from '../../../../components/common-inputs/SearchInput';
import CommonButton, { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';

import scss from './BenchmarkFilters.module.scss';

function BenchmarkFilters({ search, onSearch, onRemoveAll }) {
  const { t } = useTranslation('resonance');

  return (
    <div className={scss.wrapper}>
      <WithLabel label={`${t('search')}:`} variant={LABEL_STYLES.ROW} isBold maxWidth={360}>
        <SearchInput value={search} onChange={onSearch} size='sm' name='benchmarks-search' key='benchmarks-search' />
      </WithLabel>

      <CommonButton styleColor={BUTTON_STYLES.SECONDARY} onClick={onRemoveAll} maxWidth={200}>
        <Icon icon={ICONS.Delete} />
        {t('removeAll')}
      </CommonButton>
    </div>
  );
}

export default BenchmarkFilters;
